export default function IconA1() {
    return (
        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1272_65106)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.1635 26.7308H7.01149C6.6161 26.7308 6.2581 26.577 5.99757 26.3274C5.73581 26.0765 5.57336 25.728 5.57336 25.3429V2.12681C5.57336 1.75409 5.72539 1.41509 5.97305 1.16602C6.23481 0.902751 6.60323 0.738281 7.01149 0.738281H21.1635C21.5975 0.738281 21.9868 0.924049 22.2504 1.21808C22.4693 1.46183 22.6017 1.77894 22.6017 2.12681V25.3429C22.6017 25.7535 22.4165 26.1227 22.1235 26.3765C21.8685 26.5965 21.5326 26.7308 21.1635 26.7308Z"
                    stroke="black"
                    strokeWidth="1.05"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.69519 5.4939V7.18808" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.69519 13.697V16.7088" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.57336 10.5593H22.6017" stroke="black" strokeWidth="1.05" />
            </g>
            <defs>
                <clipPath id="clip0_1272_65106">
                    <rect width="28" height="28" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
